
import '../../styles/CAS.css';

/*Iconos*/
import Casco_icon from '../../imagenes/icons/casco.gif';
import Bases_icon from '../../imagenes/icons/bases.gif';
import Anexos_icon from '../../imagenes/icons/anexos.gif';
import Comunicado_icon from '../../imagenes/icons/comunicado.gif';
import FeErratas_icon from '../../imagenes/icons/feErratas.gif';
import EvaCV_icon from '../../imagenes/icons/evaluacion.gif';
import Entrevista_icon from '../../imagenes/icons/entrevista.gif';
import ResultFinal_icon from '../../imagenes/icons/resultados.gif';

/*Documentos*/
import Bases_pdf from '../../documentos/convocatorias_728/728_I_2026/BASE_728_I_2026.pdf';
import Anexos_doc from '../../documentos/convocatorias_728/728_I_2026/ANEXOS.docx';
import Fe_Erratas_pdf from '../../documentos/convocatorias_728/728_I_2026/FE_DE_ERRATAS_01_2026.pdf';
import Comunicado_pdf from '../../documentos/convocatorias_728/728_I_2026/COMUNICADO_I.pdf';
import Result_CV_pdf from '../../documentos/convocatorias_728/728_I_2026/RESULTADOS_DE_EVALUACION_CURRICULAR_728.pdf';
import Cronograma_pdf from '../../documentos/convocatorias_728/728_I_2026/RESULTADOS_EV_CONOCIMIENTOS_HORA_DE_ENTREVISTA_728_2026.pdf';
import ResultFinal_pdf from '../../documentos/CAS/CASI2023/RESULTADOS_FINALES_CAS_01_2023.pdf';

function R728I2026(){
  const documentos=[
    {
      titulo: 'Bases Convocatoria de trabajo',
      icon: Bases_icon,
      nombre: 'Ver Documento',
      url: Bases_pdf,
    },
    {
      titulo: 'Anexos',
      icon: Anexos_icon,
      nombre: 'Ver Anexos',
      url: Anexos_doc,
    },
    {
      titulo: 'Fe Erratas N° 001',
      icon: FeErratas_icon,
      nombre: 'Ver Publicación',
      url: Fe_Erratas_pdf,
    },
    {
      titulo: 'Comunicado',
      icon: Comunicado_icon,
      nombre: 'Ver Publicación',
      url: Comunicado_pdf,
    },
    {
      titulo: 'Resultados Evaluación Curricular',
      icon: EvaCV_icon,
      nombre: 'Ver Publicación',
      url: Result_CV_pdf,
    },
    {
      titulo: 'Resultados de la Evaluacion de Conocimientos y Cronograma de Entrevistas',
      icon: Entrevista_icon,
      nombre: 'Ver Publicación',
      url: Cronograma_pdf,
    },
  ];
  return(
    <section className='cas-section'>
      <div className='titulo-cas'>
        <img src={Casco_icon} className='titulo-icon'></img>
        <h2>Convocatoria de Trabajo Nº 001-2026 bajo el Decreto Legislativo Nº728</h2>
      </div>
      <p className='subtitulo'>Bases del Concurso para Contratación de Personal</p>
      <div className='cas-grid'>
        {documentos.map((doc, index) => (
          <div className='cas-card' key={index}>
            <img src={doc.icon} className='doc-icon'></img>
            <h3>{doc.titulo}</h3>
            <a
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            >
            {doc.nombre}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
export default R728I2026;